export enum BoxTone {
  REQUEST = 'request',
  DONE = 'done',
  NEUTRAL = 'neutral',
  YES = 'yes',
  NO = 'no',
  MAYBE = 'maybe',
  ERROR = 'error',
  ANY = 'any',
  GHOST = 'ghost',
  HIGHLIGHT = 'highlight',
}
